module.exports = __webpack_public_path__ + "img/wxp.e052f0d3.png";